import { Typography } from "@mui/material";
import React from "react";

export function BodyTypography(props: { text: string; sx?: any }) {
  return (
    <Typography
      variant="body1"
      component="h1"
      sx={{ textAlign: "left", color: "secondary.main", ...props.sx }}
    >
      {props.text}
    </Typography>
  );
}
